<template>
  <div class="company-detail-container">
    <div class="newsInfo_header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <span
              @click="goBack"
              class="newsInfo_header_bread newsInfo_header_bread_span"
          >企业名录</span
          >
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <span class="newsInfo_header_bread_span">{{
              componentInfo.name
            }}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 头部信息 -->
    <div class="company-header">
      <div class="header-content">
        <div class="company-image-container">
          <img
              :src="
              componentInfo.logo
                ? BasrUrl + componentInfo.logo
                : require('@/assets/recycling/index/empty.svg')
            "
              :alt="componentInfo.name"
              class="company-image"
          />
          <div v-if="componentInfo.rating" class="company-rating">
            <span class="rating-star">★</span>
            <span class="rating-value">{{
                componentInfo.rating.toFixed(1)
              }}</span>
          </div>
        </div>
        <div class="company-basic-info">
          <h1 class="company-name">{{ componentInfo.name }}</h1>
          <div class="company-types">
            <span
                v-for="(type, index) in componentInfo.types"
                :key="index"
                class="type-tag"
                :style="{ backgroundColor: getTagColor(index) }"
            >
              {{ type }}
            </span>
          </div>
          <div class="info-row">
            <div class="info-item">
              <i class="icon icon-location"></i>
              <span class="address">{{ componentInfo.address }}</span>
            </div>
            <div class="info-item">
              <i class="icon icon-phone"></i>
              <span class="componyPhone">{{
                  PhoneNumber(componentInfo.phone)
                }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 标签页导航 -->
    <div class="tabs-container">
      <button
          v-for="tab in tabs"
          :key="tab.id"
          class="tab-button"
          :class="{ active: activeTab === tab.id }"
          @click="activeTab = tab.id"
      >
        {{ tab.label }}
      </button>
    </div>

    <!-- 标签页内容 -->
    <div class="tab-content">
      <!-- 基本信息 -->
      <div v-show="activeTab === 'basic'" class="basic-info-section">
        <h2 class="section-title">公司简介</h2>
        <p class="company-description">{{ componentInfo.description }}</p>

        <div class="info-grid">
          <div class="info-card">
            <h3 class="info-title">成立时间</h3>
            <p class="info-value">{{ componentInfo.established }}</p>
          </div>
          <div class="info-card">
            <h3 class="info-title">员工规模</h3>
            <p class="info-value">{{ componentInfo.employees }} 人</p>
          </div>
          <div class="info-card">
            <h3 class="info-title">占地面积</h3>
            <p class="info-value">{{ componentInfo.area }} 平方米</p>
          </div>
          <div class="info-card">
            <h3 class="info-title">年处理能力</h3>
            <p class="info-value">{{ componentInfo.capacity }} 吨/年</p>
          </div>
        </div>
        <h2 class="section-title">股份占比</h2>
        <div class="echartsDom">
          <div
              class="share-pie-container"
              style="width: inherit; height: inherit"
          ></div>
        </div>
        <h2 class="section-title">资质证书</h2>
        <div class="certificates">
          <template
              v-if="
              componentInfo.certificates && componentInfo.certificates.length
            "
          >
            <div
                v-for="(cert, index) in componentInfo.certificates"
                :key="index"
                class="certificate-item"
            >
              <img
                  :src="BasrUrl + cert.image"
                  :alt="cert.name"
                  class="certificate-image"
              />
              <div class="certificate-name">
                <label>证书名称：</label>
                <div class="ertificate-text" :title="cert.name">
                  {{ cert.name }}
                </div>
              </div>
              <div class="certificate-name">
                <label>证书编号：</label>
                <div class="ertificate-text" :title="cert.certNumber">
                  {{ cert.certNumber }}
                </div>
              </div>
            </div>
          </template>
          <el-empty v-else></el-empty>
        </div>
      </div>

      <!-- 运营业务 -->
      <div v-show="activeTab === 'operation'" class="operation-section">
        <h2 class="section-title">主要运营业务</h2>
        <div class="business-list">
          <div
              v-for="(business, index) in componentInfo.businesses"
              :key="index"
              class="business-item"
          >
            <h3 class="business-name">{{ business.name }}</h3>
            <p class="business-description">{{ business.description }}</p>
            <div class="business-stats">
              <div class="stat-item">
                <span class="stat-label">年处理量:</span>
                <span class="stat-value"
                >{{ business.yearProduction }} 吨/年</span
                >
              </div>
              <div class="stat-item">
                <span class="stat-label">年产值:</span>
                <span class="stat-value">{{ business.yearValue }} 万元</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">主要设备:</span>
                <span class="stat-value">{{ business.equipment }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 物料存储 -->
      <div v-show="activeTab === 'storage'" class="storage-section">
        <div class="storage-header">
          <h2 class="section-title">物料存储情况</h2>
          <div class="storage-summary">
            <div class="summary-item">
              <span class="summary-label">总库存量</span>
              <span class="summary-value">{{ storageSummary.total }}吨</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">总价值</span>
              <span class="summary-value">{{ storageSummary.value }}万元</span>
            </div>
          </div>
        </div>

        <div class="material-list">
          <div
              v-for="material in componentInfo.materials"
              :key="material.id"
              class="material-item"
          >
            <div class="material-info">
              <h3 class="material-name">{{ material.name }}</h3>
              <p class="material-category">{{ material.category }}</p>
            </div>
            <div class="material-stats">
              <div class="stat-item">
                <span class="stat-label">当前库存:</span>
                <span class="stat-value">{{ material.stock }}吨</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">安全库存:</span>
                <span class="stat-value">{{ material.safetyStock }}吨</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">单位价值:</span>
                <span class="stat-value">{{ material.unitValue }}元/吨</span>
              </div>
            </div>
            <div class="storage-progress">
              <div class="progress-bar">
                <div
                    class="progress-fill"
                    :style="{
                    width: `${Math.min((material.stock / material.capacity) * 100, 100)}%`,
                  }"
                ></div>
              </div>
              <span class="progress-text">
                {{
                  Math.min(
                      (material.stock / material.capacity) * 100,
                      100,
                  ).toFixed(1)
                }}% (容量: {{ material.capacity }}吨)
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- 出入库记录 -->
      <div v-show="activeTab === 'records'" class="records-section">
        <div class="records-header">
          <h2 class="section-title">物料出入库记录</h2>
          <div class="records-filter">
            <select v-model="recordFilter.type" class="filter-select">
              <option value="all">全部类型</option>
              <option value="in">入库</option>
              <option value="out">出库</option>
            </select>
            <select v-model="recordFilter.material" class="filter-select">
              <option value="all">全部物料</option>
              <option
                  v-for="material in company.materials"
                  :key="material.id"
                  :value="material.id"
              >
                {{ material.name }}
              </option>
            </select>
            <input
                v-model="recordFilter.date"
                type="date"
                class="filter-input"
                placeholder="选择日期"
            />
          </div>
        </div>

        <div class="records-list">
          <div
              v-for="record in filteredRecords"
              :key="record.id"
              class="record-item"
              :class="{
              'in-record': record.type === 'in',
              'out-record': record.type === 'out',
            }"
          >
            <div class="record-type">
              <span v-if="record.type === 'in'" class="type-badge in"
              >入库</span
              >
              <span v-else class="type-badge out">出库</span>
            </div>
            <div class="record-info">
              <h3 class="record-material">
                {{ getMaterialName(record.materialId) }}
              </h3>
              <p class="record-desc">{{ record.description }}</p>
              <div class="record-meta">
                <span class="record-date">{{ formatDate(record.date) }}</span>
                <span class="record-operator"
                >操作人: {{ record.operator }}</span
                >
              </div>
            </div>
            <div class="record-quantity">
              <span v-if="record.type === 'in'" class="quantity in"
              >+{{ record.quantity }}吨</span
              >
              <span v-else class="quantity out">-{{ record.quantity }}吨</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {scrollTop} from '@/util/scrollTop';
import {maskPhoneNumber} from '@/util/maskPhoneNumber';
import * as echarts from 'echarts'; // 引入ECharts
export default {
  name: 'CompanyDetail',
  props: {
    componentInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      activeTab: 'basic',
      BasrUrl: process.env.VUE_APP_BASE_URL,
      tabs: [
        {id: 'basic', label: '基本信息'},
        {id: 'operation', label: '运营业务'},
        {id: 'storage', label: '物料存储'},
        // { id: 'records', label: '出入库记录' },
      ],
      recordFilter: {
        type: 'all',
        material: 'all',
        date: '',
      },
      company: {},
      pieChart: null, // 存储饼图实例
      isMobile: false, // 新增：设备标识
    };
  },
  watch: {
    componentInfo: {
      deep: true,
      handler() {
        this.initPieChart();
      },
    },
  },
  computed: {
    isDeviceMobile() { // 新增：计算属性，判断移动端
      return this.isMobile;
    },
    storageSummary() {
      let total = 0;
      let value = 0;
      this.componentInfo?.materials?.forEach((material) => {
        total += material.stock;
        value += (material.stock * material.unitValue) / 10000;
      });
      return {
        total: total.toFixed(1),
        value: value.toFixed(1),
      };
    },
    filteredRecords() {
      return;
      return this.company.records.filter((record) => {
        // 类型筛选
        if (
            this.recordFilter.type !== 'all' &&
            record.type !== this.recordFilter.type
        ) {
          return false;
        }

        // 物料筛选
        if (
            this.recordFilter.material !== 'all' &&
            record.materialId !== this.recordFilter.material
        ) {
          return false;
        }

        // 日期筛选
        if (this.recordFilter.date && record.date !== this.recordFilter.date) {
          return false;
        }

        return true;
      });
    },
  },
  methods: {
    // 初始化饼图
    initPieChart() {
      // 解析ratio数据
      let ratioData = [];
      try {
        if (this.componentInfo.ratio) {
          ratioData = JSON.parse(this.componentInfo.ratio);
        }
      } catch (e) {
        console.error('解析股份占比数据失败:', e);
        ratioData = [];
      }

      // 转换数据格式为ECharts所需格式
      const chartData = ratioData.map((item) => ({
        name: item.Shareholder,
        value: Number(item.ratio.replace('%', '')), // 去除百分号，只保留数字
      }));
      let otherValue = 0;
      chartData.forEach((item) => {
        otherValue += item.value;
      });
      if (otherValue < 100 && otherValue > 0) {
        chartData.push({
          name: '其他',
          value: 100 - otherValue,
        });
      }
      console.log(this.isDeviceMobile, 'chartData');
      // 获取DOM容器并初始化图表
      const pieContainer = document.querySelector('.share-pie-container');
      if (this.pieChart) {
        this.pieChart.dispose(); // 销毁已有实例
      }
      this.pieChart = echarts.init(pieContainer);

      // 字符串截断工具函数：超过maxLength则截断并加省略号
      function truncateText(text, maxLength = 10) {
        if (typeof text !== 'string') return text;
        return text.length > maxLength
            ? text.slice(0, maxLength) + '...'
            : text;
      }

      // 饼图配置
      const option = {
        tooltip: {
          trigger: 'item',
          // tooltip显示完整文字（不截断）
          formatter: (params) =>
              `${params.seriesName}<br/>${params.name}: ${params.percent}%`,
        },
        legend: {
          orient: this.isDeviceMobile ? 'vertical' : 'horizontal',
          bottom: this.isDeviceMobile ? '2%' : 0,
          textStyle: {
            fontSize: this.isDeviceMobile ? 12 : 14,
          },
          padding: [10, 0, 0, 0],
          // 图例文字截断处理
          formatter: this.isDeviceMobile?(name) => {
            const targetItem = chartData.find(item => item.name === name);
            if (!targetItem) return name;
            const totalValue = chartData.reduce((sum, item) => sum + item.value, 0);
            const percent = totalValue === 0 ? 0 : ((targetItem.value / totalValue) * 100).toFixed(1);
            return `${truncateText(name)}  ${percent}%`; // 名称 + 占比拼接
          }:(name) => truncateText(name),
          // 禁用图例点击能力
          selectedMode: false, // 关键配置：设为false则无法点击切换系列显示状态
        },
        series: [
          {
            name: '占有比例',
            type: 'pie',
            center: this.isDeviceMobile ? ['50%', '30%'] : ['50%', '40%'],
            radius: ['40%', '65%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: 'bold',
                // 鼠标 hover 时显示完整文字
                formatter: (params) => `${params.name}: ${params.percent}%`,
              },
            },
            // 饼图外侧标签文字截断处理
            label: {
              show: this.isDeviceMobile ? false : true,
              position: 'outside',
              formatter: (params) =>
                  `${truncateText(params.name)}: ${params.percent}%`,
              fontSize: 14,
              color: '#333',
              lineStyle: {
                color: '#999',
                width: 1,
              },
            },
            labelLine: {
              show: true,
              length: 15,
              length2: 20,
              smooth: false,
            },
            data: chartData,
          },
        ],
      };

      // 设置图表选项
      this.pieChart.setOption(option);

      // 监听窗口大小变化，调整图表尺寸
      window.addEventListener('resize', this.handleResize);
    },
    // 处理窗口大小变化
    handleResize() {
      if (this.pieChart) {
        this.pieChart.resize();
      }
    },
    judgeDeviceType() { // 新增：设备判断方法
      const windowWidth = window.innerWidth;
      this.isMobile = windowWidth <= 768;
      this.pieChart && this.pieChart.resize();
    },
    PhoneNumber(phone) {
      if (!phone) return '暂无';
      let nums;
      let userInfo = JSON.parse(localStorage.getItem('ordinaryUser'));
      let vipStartTime = userInfo?.userDetail?.memberStartTime || false;
      let vipEndTime = userInfo?.userDetail?.memberEndTime || false;
      let nowTime = new Date().getTime();
      let userType = userInfo?.userDetail?.userType || null;
      if (vipStartTime && vipEndTime) {
        if (
            nowTime > new Date(vipStartTime).getTime() &&
            nowTime < new Date(vipEndTime).getTime()
        ) {
          nums = phone;
        }
      } else if (userType == 3) {
        nums = phone;
      } else {
        let options = {
          maskChar: '*',
          maskLength: 4,
        };
        nums = maskPhoneNumber(phone, options);
      }
      return nums;
    },
    getTagColor(index) {
      const colors = ['#e3f2fd', '#e8f5e9', '#fff8e1', '#fce4ec', '#f3e5f5'];
      return colors[index % colors.length];
    },
    getMaterialName(id) {
      const material = this.company.materials.find((m) => m.id === id);
      return material ? material.name : '未知物料';
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
    },
    goBack() {
      this.$emit('backTopHome', true);
    },
  },
  created() {
    scrollTop();
    // 实际项目中这里应该通过API获取公司详情数据
    // const companyId = this.$route.params.id
    // fetchCompanyDetail(companyId).then(data => {
    //   this.company = data
    // })
  },
  mounted() {
    this.judgeDeviceType(); // 初始化设备判断
    window.addEventListener('resize', () => {
      this.judgeDeviceType();
      this.handleResize();
    });
    this.initPieChart();
  },
  // 组件销毁时清理图表实例和事件监听
  beforeDestroy() {
    this.pieChart && this.pieChart.dispose();
    window.removeEventListener('resize', () => {
      this.judgeDeviceType();
      this.handleResize();
    });
  },
};
</script>

<style lang="less" scoped>
.company-detail-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  font-family: 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;

  .newsInfo_header {
    padding-bottom: 20px;

    .newsInfo_header_bread {
      color: #2c3e50;
      font-weight: 600;
      cursor: pointer;
    }

    .newsInfo_header_bread:hover {
      color: #1290e5;
    }

    .newsInfo_header_bread_span {
      font-size: 16px;
    }
  }
}

/* 头部样式 */
.company-header {
  background-color: #fff;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  position: relative;
}

.back-button {
  position: absolute;
  top: 0.04167vw;
  left: -4.95833vw;
  padding: 8px 16px;
  border: none;
  background-color: #f5f5f5;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
}

.back-button:hover {
  background-color: #e0e0e0;
}

.icon-back {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 6px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23333"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>');
  background-size: contain;
}

.header-content {
  display: flex;
  align-items: center;
  padding-top: 10px;
}

.company-image-container {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  margin-right: 24px;
}

.company-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.company-rating {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 4px 8px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: white;
}

.rating-star {
  color: #ffc107;
  margin-right: 4px;
}

.company-basic-info {
  flex: 1;
}

.company-name {
  margin: 0 0 12px 0;
  font-size: 28px;
  font-weight: 600;
  color: #333;
}

.company-types {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.type-tag {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  color: #424242;
  font-weight: 500;
}

.info-row {
  display: flex;
  gap: 24px;
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 15px;
  color: #666;
}

.icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  background-size: contain;
  background-repeat: no-repeat;
}

.icon-location {
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23666"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>');
}

.icon-phone {
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23666"><path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/></svg>');
}

/* 标签页样式 */
.tabs-container {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 20px;
}

.tab-button {
  padding: 12px 24px;
  border: none;
  background: none;
  font-size: 15px;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
}

.tab-button:hover {
  color: #333;
}

.tab-button.active {
  color: #4caf50;
}

.tab-button.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #4caf50;
}

/* 内容区域样式 */
.section-title {
  margin: 24px 0 16px 0;
  font-size: 22px;
  font-weight: 600;
  color: #333;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.company-description {
  line-height: 1.8;
  color: #555;
  font-size: 20px;
  margin-bottom: 24px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.info-card {
  background-color: #f9f9f9;
  font-size: 15px;
  border-radius: 8px;
  padding: 16px;
}

.info-title {
  margin: 0 0 8px 0;
  font-size: 20px;
  color: #666;
}

.info-value {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  color: #333;
}

.certificates {
  display: flex;
  gap: 16px;

  .certificate-name {
    margin-top: 8px;

    label {
      font-weight: 600;
      color: #666666;
    }

    .ertificate-text {
      width: 200px;
      height: 32px;
      color: #333333;
      margin-top: 5px;
      display: -webkit-box; /* 使用旧版弹性盒模型 */
      -webkit-line-clamp: 2; /* 限制显示行数 */
      -webkit-box-orient: vertical; /* 垂直排列 */
      overflow: hidden; /* 隐藏溢出内容 */
      text-overflow: ellipsis; /* 显示省略号 */
      /* 首选方案：智能断行 */
      word-wrap: break-word;
      word-break: break-word;
      overflow-wrap: anywhere;

      /* 或者强制断行（更激进） */
      /* word-break: break-all; */

      /* 对于特定场景可以添加连字符 */
      hyphens: auto;
    }
  }
}

.certificate-item {
  width: 240px;
  padding: 10px 20px;
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0 0.20833vw 0.625vw rgba(0, 0, 0, 0.05);
  margin-right: 20px;
}

.certificate-image {
  width: 100%;
  height: 160px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

/* 运营业务样式 */
.business-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 24px;
}

.business-item {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 16px;
}

.business-name {
  margin: 0 0 8px 0;
  font-size: 22px;
  font-weight: 600;
  color: #333;
}

.business-description {
  margin: 0 0 12px 0;
  color: #555;
  line-height: 1.6;
  font-size: 20px;
}

.business-stats {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 12px;
}

.stat-item {
  display: flex;
  font-size: 14px;
}

.stat-label {
  color: #666;
  font-size: 20px;
  margin-right: 8px;
}

.stat-value {
  color: #333;
  font-weight: 500;
  font-size: 20px;
}

.partners {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
}

.partner-logo {
  height: 40px;
  max-width: 120px;
  object-fit: contain;
  filter: grayscale(100%);
  opacity: 0.7;
  transition: all 0.3s ease;
}

.partner-logo:hover {
  filter: grayscale(0);
  opacity: 1;
}

/* 物料存储样式 */
.storage-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.storage-summary {
  display: flex;
  gap: 24px;
}

.summary-item {
  text-align: center;
}

.summary-label {
  display: block;
  font-size: 16px;
  color: #666;
}

.summary-value {
  display: block;
  font-size: 20px;
  font-weight: 600;
  color: #4caf50;
}

.material-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.material-item {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 16px;
}

.material-info {
  margin-bottom: 12px;
}

.material-name {
  margin: 0 0 4px 0;
  font-size: 22px;
  font-weight: 500;
  color: #333;
}

.material-category {
  margin: 0;
  font-size: 20px;
  color: #666;
}

.material-stats {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 12px;
  margin-bottom: 12px;
}

.storage-progress {
  margin-top: 12px;
}

.progress-bar {
  height: 8px;
  background-color: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 4px;
}

.progress-fill {
  height: 100%;
  background-color: #4caf50;
  border-radius: 4px;
}

.progress-text {
  font-size: 18px;
  color: #666;
}

/* 出入库记录样式 */
.records-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.records-filter {
  display: flex;
  gap: 12px;
}

.filter-select,
.filter-input {
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
}

.records-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.record-item {
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 12px 16px;
}

.record-item.in-record {
  border-left: 4px solid #4caf50;
}

.record-item.out-record {
  border-left: 4px solid #ff5252;
}

.record-type {
  width: 60px;
  flex-shrink: 0;
}

.type-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.type-badge.in {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.type-badge.out {
  background-color: #ffebee;
  color: #c62828;
}

.record-info {
  flex: 1;
}

.record-material {
  margin: 0 0 4px 0;
  font-size: 15px;
  font-weight: 500;
}

.record-desc {
  margin: 0 0 4px 0;
  font-size: 13px;
  color: #666;
}

.record-meta {
  display: flex;
  gap: 12px;
}

.record-date,
.record-operator {
  font-size: 12px;
  color: #999;
}

.record-quantity {
  width: 80px;
  text-align: right;
  font-weight: 500;
}

.quantity.in {
  color: #2e7d32;
}

.quantity.out {
  color: #c62828;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .company-detail-container {
    max-width: 100% !important;
  }

  .header-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .company-image-container {
    margin-right: 0;
    margin-bottom: 16px;
    width: unset !important;
    height: unset !important;
  }

  .info-grid {
    grid-template-columns: repeat(auto-fill, minmax(24%, 1fr)) !important;
  }

  .info-row {
    flex-direction: column;
    gap: 8px;
  }

  .tabs-container {
    overflow-x: auto;
    white-space: nowrap;
  }

  .records-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .records-filter {
    width: 100%;
    flex-direction: column;
  }

  .echartsDom {
    width: 100%;
    height: 445px !important;
  }
  .newsInfo_header_bread_span {
    font-size: 14px !important;
  }
  .company-name {
    font-size: 16px !important;
  }
  .icon-location {
    width: 14px !important;
    height: 14px !important;
    background-size: 14px !important;
  }
  .address{
    font-size: 12px !important;
  }
  .icon-phone{
    width: 14px !important;
    height: 14px !important;
    background-size: 14px !important;
  }
  .componyPhone{
    font-size: 12px !important;
  }
  .tab-button {
    font-size: 15px !important;
  }
  .section-title {
    font-size: 14px !important;
  }
  .company-description {
    font-size: 14px !important;
  }
  .info-title {
    font-size: 12px !important;
  }
  .info-value {
    font-size: 12px !important;
  }
  .business-name {
    font-size: 14px !important;
  }
  .business-description {
    font-size: 14px !important;
  }
  .stat-label {
    font-size: 12px !important;
  }
  .stat-value {
    font-size: 12px !important;
  }
  .material-name {
    font-size: 14px !important;
  }
  .material-category {
    font-size: 14px !important;
  }
  .progress-text {
    font-size: 12px !important;
  }
  .business-stats {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)) !important;
  }
  .material-stats{
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)) !important;
  }
  .summary-label {
    font-size: 14px !important;
  }
  .summary-value {
    font-size: 14px !important;
  }
}

.address {
  font-size: 20px;
}

.componyPhone {
  font-size: 20px;
}

::v-deep .tab-button {
  font-size: 20px;
}

.echartsDom {
  width: 100%;
  height: 345px;
}
</style>
